import React from 'react';
import { FormControl, TextField } from '@material-ui/core';

import { InputControlProps } from './InputControl.interfaces';
import { UtilService } from 'app/services/util.service';
import { ControlContainer } from 'app/components/ControlContainer';
import { DoneAdornment } from 'app/components/DoneAdornment';
import { useInputControl } from 'app/shared/hooks/controls/useInputControl';

const InputControl = (props: InputControlProps) => {
  const {
    disabled,
    maxLength,
    input,
    meta,
    meta: { touched, valid },
    label,
    placeholder,
    subLabel,
    tooltip,
    width,
    helperText,
    multiline,
    rows,
  } = props;

  const {
    focused,
    onFocus,
    handleChange,
    handleBlur,
    handleClick,
  } = useInputControl(props);

  return (
    <FormControl fullWidth>
      <ControlContainer
        inputId={input.name}
        meta={meta}
        width={width}
        floating
        tooltip={tooltip}
        isQuestionValid={props.isQuestionValid}
        floated={focused || UtilService.hasValue(input.value)}
        helperText={helperText}
        focused={focused}
      >
        <TextField
          {...input}
          disabled={disabled}
          id={input.name}
          inputProps={{
            maxLength,
          }}
          InputLabelProps={{
            shrink: UtilService.hasValue(input.value) || focused,
          }}
          onChange={handleChange}
          onBlur={handleBlur}
          onClick={handleClick}
          onFocus={onFocus}
          label={subLabel ? `${label} - ${subLabel}` : label}
          placeholder={placeholder}
          fullWidth
          InputProps={{
            startAdornment: !multiline &&
              !focused &&
              UtilService.hasValue(input.value) && <DoneAdornment />,
          }}
          error={touched && !valid}
          variant={'outlined'}
          margin={'dense'}
          multiline={multiline}
          rows={rows}
        />
      </ControlContainer>
    </FormControl>
  );
};

export default InputControl;
